import { all, call, fork, takeLatest } from 'redux-saga/effects';

import * as constants from './meeting-boards.constants';
import * as types from './meeting-boards.types';
import * as services from './meeting-boards.saga-services';

/***BOARDS***/
function* invokeCreateBoard(action: types.ICreateBoard) {
  yield call(services.createBoard, action.payload);
}

function* invokeUpdateBoard(action: types.IUpdateBoard) {
  yield call(services.updateBoard, action.payload.id, action.payload.data);
}
function* invokeDeleteBoard(action: types.IDeleteBoard) {
  yield call(services.deleteBoard, action.payload);
}

function* invokeSaveBoardSocket(action: types.ISaveBoardSocket) {
  yield call(services.saveBoardSocket, action.payload);
}
function* invokeDeleteBoardSocket(action: types.ISaveBoardSocket) {
  yield call(services.deleteBoardSocket, action.payload);
}
function* invokeSaveBoardOrder(action: types.ISaveBoardOrder) {
  yield call(services.saveBoardOrder, action.payload.boardIds);
}
function* invokeDndBoard(action: types.IDndBoard) {
  yield call(services.boardDnd, action.payload.result, action.payload.meetingId);
}

/***BOARDLISTS***/
function* invokeCreateBoardList(action: types.ICreateBoardList) {
  yield call(services.createBoardList, action.payload);
}

function* invokeUpdateBoardList(action: types.IUpdateBoardList) {
  yield call(services.updateBoardList, action.payload.id, action.payload.data);
}
function* invokeDeleteBoardList(action: types.IDeleteBoardList) {
  yield call(services.deleteBoardList, action.payload);
}
function* invokeMoveBoardList(action: types.IMoveBoardList) {
  //yield call(services.moveBoardList, action.payload);
}
function* invokeSaveBoardListSocket(action: types.ISaveBoardListSocket) {
  yield call(services.saveBoardListSocket, action.payload);
}

function* invokeDeleteBoardListSocket(action: types.IDeleteBoardListSocket) {
  yield call(services.deleteBoardListSocket, action.payload);
}

function* invokeSaveBoardListOrder(action: types.ISaveBoardListOrder) {
  yield call(services.saveBoardListOrder, action.payload.listIds);
}
function* invokeDndBoardList(action: types.IDndBoardList) {
  yield call(services.boardListDnd, action.payload.result, action.payload.meetingId, action.payload.boardId);
}

export function* watchMeetingBoardsPurePageSaga() {
  /***BOARDS***/
  yield takeLatest(constants.CREATE_BOARD, invokeCreateBoard);
  yield takeLatest(constants.UPDATE_BOARD, invokeUpdateBoard);
  yield takeLatest(constants.DELETE_BOARD, invokeDeleteBoard);
  yield takeLatest(constants.SAVE_BOARD_SOCKET, invokeSaveBoardSocket);
  yield takeLatest(constants.SAVE_BOARD_ORDER, invokeSaveBoardOrder);
  yield takeLatest(constants.DELETE_BOARD_SOCKET, invokeDeleteBoardSocket);
  yield takeLatest(constants.DND_BOARD, invokeDndBoard);
  yield takeLatest(constants.SAVE_BOARD_ORDER, invokeSaveBoardOrder);
  /***BOARDLISTS***/
  yield takeLatest(constants.CREATE_BOARD_LIST, invokeCreateBoardList);
  yield takeLatest(constants.UPDATE_BOARD_LIST, invokeUpdateBoardList);
  yield takeLatest(constants.DELETE_BOARD_LIST, invokeDeleteBoardList);
  yield takeLatest(constants.MOVE_BOARD_LIST, invokeMoveBoardList);
  yield takeLatest(constants.SAVE_BOARD_LIST_SOCKET, invokeSaveBoardListSocket);
  yield takeLatest(constants.DELETE_BOARD_LIST_SOCKET, invokeDeleteBoardListSocket);
  yield takeLatest(constants.DND_BOARD_LIST, invokeDndBoardList);
  yield takeLatest(constants.SAVE_BOARD_LIST_ORDER, invokeSaveBoardListOrder);
}

export function* watchMeetingBoardsPageStorageSaga() {
  yield all([watchMeetingBoardsPurePageSaga].map(fork));
}
